module.exports = __webpack_public_path__ + "img/火龙果11.1bf0e022.png";